<template>
  <div class="row map">
    <!-- <div
      v-if="loading_i"
      class="d-flex flex-column justify-content-center align-items-center"
    >
      <i
        class="zmdi zmdi-spinner zmdi-hc-spin"
        style="font-size: 2rem; margin-right: 20px"
      ></i>
    </div> -->
    <!-- @update:center="centerUpdated" -->

    <v-map
      :zoom="zoom"
      :center="center"
      :options="{ attributionControl: false, zoomControl: false }"
      @update:zoom="zoomUpdated"
      style="border-radius: 5px; z-index: 2; position: relative"
      class="box"
      v-if="!loading_i"
    >
      <v-icondefault></v-icondefault>
      <v-tilelayer :url="url" :attribution="attribution"></v-tilelayer>
      <v-tilelayer :url="urlLabel" :attribution="attribution"></v-tilelayer>

      <v-control
        class="example-custom-control m-2"
        style="border-radius: 10px; opacity: 75%"
        :position="'bottomright'"
      >
        <div class="py-2 px-2" style="font-weight: bold">
          <div><img :src="awlr_im" class="px-1 pb-1" />AWLR</div>
          <!-- <div><img :src="arr_im" class="px-1 py-1" />ARR</div>
          <div><img :src="aws_im" class="px-1 pt-1" />AWS</div> -->
        </div>
      </v-control>
      <!-- <v-marker-cluster @clusterclick="click()" @ready="ready"> -->
      <span v-for="station in stations" :key="station.id">
        <span
          ><v-marker
            :lat-lng="latLng(station[0].latitude, station[0].longitude)"
          >
            <span v-if="station[0].station_type == 1">
              <v-icon :icon-size="dynamicSize" :icon-url="icon_arr"> </v-icon>
            </span>
            <span v-if="station[0].station_type == 2">
              <v-icon :icon-size="dynamicSize" :icon-url="icon_awlr"> </v-icon>
            </span>
            <span v-if="station[0].station_type == 3">
              <v-icon :icon-size="dynamicSize" :icon-url="icon_aws"> </v-icon>
            </span>
            <v-popup>
              <div style="max-width: 18rem; color: #0a2481">
                <div>
                  <div>
                    <span style="font-size: 1rem; font-weight: 600">{{
                      station[0].station_name
                    }}</span>
                  </div>
                  <div class="mt-2">
                    {{ station[1].table.date }}
                  </div>
                  <ul class="m-0 p-0">
                    <li
                      v-for="(item, index) in getFilteredTable(
                        station[1].table,
                      )"
                      :key="index"
                      class="flex"
                    >
                      <span>{{ item.sensor }}</span
                      >: {{ item.data }} {{ item.symbol }}
                    </li>
                  </ul>
                </div>
              </div>
            </v-popup>
          </v-marker>
        </span>
      </span>
      <!-- </v-marker-cluster> -->
      <v-control-scale
        position="topright"
        :imperial="false"
        :metric="true"
      ></v-control-scale>
    </v-map>
  </div>
</template>

<script>
import * as Vue2Leaflet from "vue2-leaflet";
// import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
// import axios from "axios";
import awlr_im from "@/assets/icons/map/mawlr.svg";
import arr_im from "@/assets/icons/map/marr.svg";
import aws_im from "@/assets/icons/map/maws.svg";
import awlr_i from "@/assets/icons/map/awlr.svg";
import arr_i from "@/assets/icons/map/arr.svg";
import aws_i from "@/assets/icons/map/aws.svg";
import edit_i from "@/assets/icons/map/edit.svg";
import detail_i from "@/assets/icons/map/detail.svg";

import mtc_i from "@/assets/icons/map/mtc.svg";
import ok_i from "@/assets/icons/map/ok.svg";
import s1_i from "@/assets/icons/map/s1.svg";
import s2_i from "@/assets/icons/map/s2.svg";
import s3_i from "@/assets/icons/map/s3.svg";

export default {
  name: "StationMap",
  props: ["stations", "loading_i", "status", "balai", "zoom", "center"],
  components: {
    "v-map": Vue2Leaflet.LMap,
    "v-tilelayer": Vue2Leaflet.LTileLayer,
    "v-icondefault": Vue2Leaflet.LIconDefault,
    "v-marker": Vue2Leaflet.LMarker,
    "v-popup": Vue2Leaflet.LPopup,
    // "v-marker-cluster": Vue2LeafletMarkerCluster,
    "v-control-scale": Vue2Leaflet.LControlScale,
    "v-icon": Vue2Leaflet.LIcon,
    "v-control": Vue2Leaflet.LControl,
  },

  data() {
    return {
      // url: "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
      url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      urlLabel:
        "https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png",

      attribution: "",
      // zoom: 4,
      // center: undefined,
      iconSize: [20],
      icon_awlr: awlr_im,
      icon_arr: arr_im,
      icon_aws: aws_im,
      awlr_im,
      arr_im,
      aws_im,
      awlr_i,
      arr_i,
      aws_i,
      edit_i,
      detail_i,
      mtc_i,
      ok_i,
      s1_i,
      s2_i,
      s3_i,
      role: "",
    };
  },
  computed: {
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
  },
  methods: {
    getFilteredTable(table) {
      return table.array_table_label
        .map((sensor, index) => ({
          sensor,
          data: table.weather_data[index],
          symbol: table.array_act_symbol[index],
        }))
        .filter((item) => item.sensor !== null && item.data !== null);
    },
    click: (e) => console.log("clusterclick", e),
    ready: (e) => console.log("ready", e),
    latLng: function (lat, lng) {
      return [lat, lng];
    },
    // centerUpdated(center) {
    //   this.center = center;
    // },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    formatDate(date) {
      var monthShortNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agu",
        "Sep",
        "Okt",
        "Nov",
        "Des",
      ];
      var d = new Date(date),
        year = d.getFullYear(),
        month = "" + d.getMonth(),
        day = "" + d.getDate();

      if (day.length < 2) day = "0" + day;
      return [day, monthShortNames[month], year].join(" ");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours(),
        minute = "" + d.getMinutes(),
        second = d.getSeconds();

      if (hour.length < 2) hour = "0" + hour;
      if (minute.length < 2) minute = "0" + minute;
      if (second.length < 2) second = "0" + second;

      return [hour, minute].join(":");
    },
  },
};
</script>

<style scoped>
.map {
  height: 40vh;
}

.example-custom-control {
  background: #fff;
}

.example-custom-control {
  background: #fff;
}

.imgSZ {
  height: 38px;
}

.iconSZ {
  height: 24px;
}

.statSZ {
  height: 22px;
}

ul {
  list-style: none;
  display: table;
}

li {
  display: table-row;
}

c {
  display: table-cell;
  padding-right: 1em;
}

@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>

<style scoped src="@/assets/css/figma.css"></style>
